import type { BankAddressField } from '@/entities/bank-address';
import type {
  CreateBankAddressFormValues,
  CreateSavedBankAddressRequestDto,
  CreateBankAddressRequestParam,
} from './types';

export const mapFieldsToRequestParams = (
  fields: BankAddressField[],
  values: CreateBankAddressFormValues
): CreateSavedBankAddressRequestDto => {
  const params: CreateBankAddressRequestParam[] = fields
    .map(field => {
      const value = values[field.id];
      if (value == null || value === '') return null;

      return {
        paramId: field.id,
        paramName: field.placeholder,
        paramValue: String(value),
      };
    })
    .filter(Boolean) as CreateBankAddressRequestParam[];

  return {
    templateName: values.templateName || '',
    params,
  };
};
